import GenDuo from '../public/genduo'
import H2Title from '../public/h2Title'
import { BASE_URL } from '../../api/api'

const Ljhd = ({ sessiontList = {} }) => {
  const { channel, list = [] } = sessiontList
  const { id = '' } = channel || {}

  return (
    <div className="w-full lg:mt-[60px] bg-[#0189D5] lg:bg-white">
      <div className="flex justify-center lg:justify-between items-center">
        <p className="hidden lg:block"></p>
        <H2Title className="text-white lg:text-[#0189D5]" title="历届活动" />
        <GenDuo href={`/ljhd/channel_id/${id}`} className="hidden lg:block" />
      </div>
      <div className=" overflow-scroll lg:overflow-auto hidden-scrollbar">
        <div className="w-[1000px] lg:w-full flex justify-between lg:bg-[#0181C9] p-5 lg:mt-9">
          {list.map(({ title, image = '', id: listId, year, isnew }, key) => (
            <a
              target="_blank"
              href={`${isnew == 1 ? `/?ljhdid=${year}` : `/ljList/channel_id/${id}?year=${year}`}`}
              key={listId}
              rel="noreferrer"
            >
              <div key={key} className="w-[273px] bg-white mr-[30px] lg:mr-0">
                <img
                  className="border border-white"
                  width="100%"
                  src={`${BASE_URL}${image}`}
                  style={{ height: 180 }}
                  alt=""
                />
                <p className="text-white bg-[#0181C9] pt-4">{title}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Ljhd
